import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { ShellTrackHandlers } from '@cigna/chcp/shared/analytics-util';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-evernorth-search',
  templateUrl: './evernorth-search.component.html',
  styleUrls: ['./evernorth-search.component.scss'],
})
export class EvernorthSearchComponent {
  @Input() isResourcesPage = false;
  @Input() isSecure = false;

  isInputFocused = false;

  @ViewChild('searchInput', { read: ElementRef, static: false })
  searchInput: ElementRef;

  @ViewChild('searchForm', { read: ElementRef, static: false })
  searchForm: ElementRef;

  constructor(
    private analytics: ShellTrackHandlers,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {}

  submitSearch() {
    if (this.searchTerm) {
      this.analytics.trackEventOther({}, 'Search', 'ac22625', {
        eVar27: this.searchTerm,
        eVar120: 'site-search-icon',
        eVar119: 'US1927854',
        prop27: this.searchTerm,
      });
      return true; // submit the form
    }
    return false;
  }

  handleIconClick() {
    if (this.searchTerm !== '') {
      this.searchForm.nativeElement.submit();
    } else {
      this.searchInput.nativeElement.focus();
    }
  }

  get searchTerm(): string {
    return (this.searchInput && this.searchInput.nativeElement.value) || '';
  }

  get formAction(): string {
    const resultsPagePath = `/app/resources/results/${
      this.isSecure ? 'secure' : 'public'
    }`;

    if (this.isResourcesPage) {
      const cdnEnvironment = this.envConfig.api.gateways.cdn;
      let hostname = 'https://provider.evernorth.com';
      if (cdnEnvironment.includes('d.static')) {
        hostname = 'https://d-provider-behavioral.cigna.com';
      }
      if (cdnEnvironment.includes('a.static')) {
        hostname = 'https://a-provider-behavioral.cigna.com';
      }
      if (cdnEnvironment.includes('v.static')) {
        hostname = 'https://v-provider-behavioral.cigna.com';
      }
      if (cdnEnvironment.includes('chk.static')) {
        hostname = 'https://chk-provider-behavioral.cigna.com';
      }

      return `${hostname}${resultsPagePath}`;
    }
    return resultsPagePath;
  }
}
